import { render, staticRenderFns } from "./registerSuccess.vue?vue&type=template&id=39d71a7a&scoped=true&"
var script = {}
import style0 from "./registerSuccess.vue?vue&type=style&index=0&id=39d71a7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d71a7a",
  null
  
)

export default component.exports